import { useState } from 'react';
import styles from './BulkUpload.module.css';
import HeadingAndIcon from '../../components/HeadingAndIcon/HeadingAndIcon';
import ToClose from '../../components/ToClose/ToClose';
import { ReactComponent as UploadIcon } from '../../assets/images/upload-icon.svg';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../redux/slices/modalSlice'; // Adjust path
import IconAndName from '../../components/IconAndName/IconAndName';
const BulkUpload = ({
  heading = 'Bulk Upload',
  icon = <UploadIcon />,
  acceptedTypes = [
    'text/csv',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ],
  acceptString = '.csv, .xlsx, .xls',
}) => {
  const dispatch = useDispatch();
  const [file, setFile] = useState(null);
  const [error, setError] = useState('');

  const processFile = (file) => {
    if (!file) return;

    if (!acceptedTypes.includes(file.type)) {
      setError('Only .csv or Excel files are allowed.');
      return;
    }

    setError('');
    setFile(file);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFile = e.dataTransfer.files[0];
    processFile(droppedFile);
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    processFile(selectedFile);
  };

  const preventDefaults = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleClose = () => {
    dispatch(closeModal());
  };

  return (
    <div className={styles.container}>
      <div className={styles.modalContainer}>
        <div className={styles.modalHeader}>
          <HeadingAndIcon icon={icon} heading={heading} />
          <ToClose onClose={handleClose} />
        </div>

        <div
          className={styles.uploadArea}
          onDrop={handleDrop}
          onDragOver={preventDefaults}
          onDragEnter={preventDefaults}
        >
          <div className={styles.ButtonContainer}>
            <IconAndName
              title="Download Format"
              bgColor="Primary_Color"
              onClick={() => {}}
            />
          </div>

          <label htmlFor="file-upload" className={styles.uploadLabel}>
            <UploadIcon className={styles.uploadIcon} />
            <p className={styles.uploadText}>Drop or Browse Files from here</p>
            <input
              id="file-upload"
              type="file"
              onChange={handleFileChange}
              className={styles.fileInput}
              accept={acceptString}
            />
          </label>

          {file && <p className={styles.fileName}>Selected: {file.name}</p>}
          {error && <p className={styles.errorText}>{error}</p>}
          <div className={styles.instructions}>
            <p className={styles.instructionsHeader}>Instructions to upload:</p>
            <ul>
              <li>
                Download csv format to upload student and make sure to not
                remove the header of the file.
              </li>
              <li>Ensure date of birth to be in format DD-MM-YYYY.</li>
              <li>
                The email and phone number for both parents should not be the
                same.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkUpload;
